import Axios from "axios";
import Swal from "sweetalert2";
import { handleSessionExpiration } from "./handleSessionExpiration";

const axios = Axios.create({
    baseURL: process.env.NODE_ENV === "development"
        ? "/api"
        : process.env.REACT_APP_URLAPI,
    timeout: 100000,
    withCredentials: true,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    withXSRFToken: true,
});

export const initializeCsrf = () => {
    return axios.get("csrf-cookie");
};

axios.interceptors.response.use((response) => response,
    async (error) => {
        const { data } = error.response || {};
        const requestConfig = error.config || {};

        if (data?.message === "Unauthenticated." && !requestConfig._skipSessionRefresh) {
            await handleSessionExpiration(error, axios);
        }
        return Promise.reject(error);
    }
)
export default axios;

export const services = ({ method, service, body }) => {
    switch (method) {
        case "GET":
            let url = `${service}`;

            return axios.get(url).then((r) => {
                return response(r)
            }).catch((err) => {
                return response(err.response);
            });
        case "POST":
            return axios.post(`${service}`, body).then((r) => {
                return response(r);
            }).catch((err) => {
                return response(err.response);
            });
        case "PUT":
            return axios.put(`${service}`, body).then((r) => {
                return response(r);
            }).catch((err) => {
                return response(err.response);
            });
        case "DELETE":
            return axios.delete(`${service}`).then((r) => {
                return response(r);
            }).catch((err) => {
                return response(err.response);
            });
        default:
            break;
    }
}

const arrayResponse = [
    200, 201, 404, 409, 422, 423, 500
];

const response = (r) => {

    if (r === undefined) {
        return false;
    }

    if (r.status === 401) {
        Swal.fire({
            icon: 'error',
            title: 'credenciales invalidas',
            showConfirmButton: false,
            timer: 1000
        });
        return false
    }

    if (arrayResponse.includes(r.status)) {
        return { status: r.status, data: r.data }
    }

    return { status: r.status, errors: r.data.error }
}
